import React, { Component } from 'react';
import {http} from '../misc/http';
import Layout from '../layout/Main';
import List from '../components/ListOfOrganizer/List';
import FormDetil from '../components/ListOfOrganizer/FormDetil';

export default class ListOfOrganizer extends Component {
  state = {
    showForm: '',
    organizer: {},
    organizerList: [],
    organizerListMaster: [],
  }

  componentDidMount = async () => {
    const {id} = this.props.match.params;
    await this.handleGetAll()
    this.handleFindData(id);
  }

  handleGetAll = async () => {
    let params = {
      method:'GET',
      path: 'organizer',
      showMessage: false
    }
    let {data} = await http(params);
    if (data.status === true && data.code === 200) {
      let {organizerList} = this.state;
      organizerList = data.data;
      this.setState({organizerList, organizerListMaster: organizerList})
    }
  }

  handleFindData = async (id) => {
    let {organizerList} = this.state;
    let organizer = await organizerList.find(e => e._id === id)
    if (organizer) this.handleShowForm(organizer)
  }

  handleShowForm = (organizer) => {
    this.setState({showForm:'show', organizer})
  }

  handleCloseForm = () => {
    this.setState({showForm: ''})
  }

  handleSearch = async (keyword) => {
    if (keyword !== ''){
      let {organizerList} = this.state;
      organizerList =  organizerList.filter(e => {
        let regex = `^.*${keyword}.*$`
        let regEx = new RegExp(regex, 'gi')
        return e.companyName.match(regEx) !== null
      })
      this.setState({organizerList})
    } else this.setState({organizerList: this.state.organizerListMaster})
  }

  render() {
    return (
      <Layout>
        <FormDetil showForm={this.state.showForm} handleClose={this.handleCloseForm} organizer={this.state.organizer}/>
        <List OrganizerList={this.state.organizerList} handleShowForm={this.handleShowForm} handleSearch={this.handleSearch}/>
      </Layout>
    )
  }
}
